module.exports = __webpack_public_path__ + "static/mofikoya-7c28e1ec62cc4a2743fabf2a2584244c.png";